import { ChartSortEnum } from '../interfaces';
import { IChartLine } from './useChartLines';
import { ISingleDateData } from './useSingleDateData';

interface IProps {
  visibleLines: IChartLine[];
  sort: ChartSortEnum;
  data: ISingleDateData[];
}

export default ({
  visibleLines,
  sort,
  data,
}: IProps): [IChartLine[], ISingleDateData[]] => {
  const sortedData = [...data];
  const sortedVisibleLines: IChartLine[] = [];
  if (sort === ChartSortEnum.ASC) {
    sortedData.sort((a, b) => (a.value ?? 0) - (b.value ?? 0));
  } else if (sort === ChartSortEnum.DESC) {
    sortedData.sort((a, b) => (b.value ?? 0) - (a.value ?? 0));
  }

  // re-arrange visbile lines according to sorted data
  for (const currData of sortedData) {
    const line = visibleLines.find((l) => l.name === currData.name);
    if (line) {
      sortedVisibleLines.push(line);
    }
  }

  return [sortedVisibleLines, sortedData];
};
